import {
  requests
} from '../../../api/agent'

export default {
  getReasonTypes: (params) => requests.getWithParams('/ReReasonTypes/ListAllPaged', params),
  getReasonByName: (params) => requests.getWithParams('/ReReasonTypes/getByName', params),
  createReasonType: (params) => requests.post('/ReReasonTypes/CreateReasonType', params),
  deleteReasonType: (params) => requests.post('/ReReasonTypes/DeleteReasonType', params),
  updateReasonType: (params) => requests.post('/ReReasonTypes/UpdateReasonType', params),
  restoreReasonType: (params) => requests.post('/ReReasonTypes/RestoreReasonType', params)
}